import React, {createContext, useState} from 'react';
import {  Paper } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { styled } from "@mui/material/styles";
import Container from '@mui/material/Container';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Donation from './forms/Donation';
import Pooja from './forms/Pooja';
import ChykconForm from './forms/ChykconForm';
import ElementaryLockin from './forms/ElementaryLockin';
import HighSchoolLockin from './forms/HighSchoolLockin';
import MiddleSchoolLockin from './forms/MiddleSchoolLockin';
import LaborDayRetreat from './forms/LaborDayRetreat';
import BanquetForm from './forms/BanquetForm';
import EndEventForm from './forms/EndEventForm';
import Reports from './forms/Reports';
import BalaviharRegistration from './pages/BalaviharRegistration';
import CulturalRegistration from './forms/CulturalRegistration';
import EventTypesForm from './forms/EventTypesForm';
import RaasGarba from './forms/RaasGarba';
import TshirtInfoForm from './forms/TshirtInfoForm';
import HoliWalkthon from './forms/HoliWalkthon';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { MemberProfileProvider } from './context/MemberProfileContext';
import SignInForm from './components/Authentication/SignInForm';
import ForgotUsername from './components/Authentication/ForgotUsername';
import ForgotPassword from './components/Authentication/ForgotPassword';
import ChangePassword from './components/Authentication/ChangePassword';
import SameHousehold from './components/Authentication/SameHousehold';
import ValidateOTP from './components/Authentication/ValidateOTP';
import Dashboard from './pages/Dashboard/Dashboard';
import HeaderBar from './components/HeaderBar/HeaderBar';
import HouseholdMembers from './components/HouseholdMembers';
import EventTxnsHistory from './components/EventTxnsHistoryComp';
import DonationHistory from './components/DonationHistoryComp';
import BalaviharHistory from './components/BalaviharHistoryComp';
import { TimerProvider } from './context/TimerContext';
import FAQSupport from './components/FAQSupport';
import { useEffect } from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
const drawerWidth = 250;



const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));

export const DataContext = createContext();

function App() {

  const [events, setEvents] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
    

  return (
    <div className="App">
      <CssBaseline />
      <Container component="main" maxWidth="xl" sx={{ mb: 4, display: 'flex', justifyContent: 'center' }} >
        <DemoPaper variant="elevation" sx={{ width: '100%', maxWidth: '1200px', position: 'relative' }}>
        <DataContext.Provider value={ {events, setEvents}}>
        <MemberProfileProvider>
        <UserProvider>
         <AuthProvider>
         <Router>
          <TimerProvider>
          <HeaderBar drawerOpen={drawerOpen} handleDrawerToggle={handleDrawerToggle}/>
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 3,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start'
              }}
            >
              <Box sx={{ width: '100%', maxWidth: '900px' }}>
                <Routes>
                  <Route path="/" element={<SignInForm />} />
                  <Route path="/Donation" element={<Donation />} />
                  <Route path="/Pooja" element={<Pooja />} />
                  <Route path="/ChykconForm" element={<ChykconForm />} />
                  <Route path="/ElementaryLockinForm" element={<ElementaryLockin />} />
                  <Route path="/MiddleSchoolLockinForm" element={<MiddleSchoolLockin />} />
                  <Route path="/HighSchoolLockinForm" element={<HighSchoolLockin />} />
                  <Route path="/LaborDayRetreat" element={<LaborDayRetreat />} />
                  <Route path="/BVRegistration" element={<BalaviharRegistration />} />
                  <Route path="/Languages" element={<CulturalRegistration />} />
                  <Route path="/HoliWalkthon" element={<HoliWalkthon />} />
                  <Route path="/Banquet" element={<BanquetForm />} />
                  <Route path="/RaasGarba" element={<RaasGarba />} />
                  <Route path="/Reports" element={<Reports />} />
                  <Route path="/EventTypesForm" element={<EventTypesForm />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/ForgotUsername" element={<ForgotUsername />} />
                  <Route path="/ForgotPassword" element={<ForgotPassword />} />
                  <Route path="/ChangePassword" element={<ChangePassword />} />
                  <Route path="/ValidateOTP" element={<ValidateOTP />} />
                  <Route path="/HouseholdMembers" element={<HouseholdMembers />} />
                  <Route path="/EventTxnsHistoryComp" element={<EventTxnsHistory />} />
                  <Route path="/DonationHistoryComp" element={<DonationHistory />} />
                  <Route path="/BalaviharHistoryComp" element={<BalaviharHistory />} />
                  <Route path="/SameHousehold" element={<SameHousehold />} />
                  <Route path="/FAQSupport" element={<FAQSupport />} />
                </Routes>
              </Box>
            </Box>
          </TimerProvider>
          </Router>
          </AuthProvider>
          </UserProvider>
          </MemberProfileProvider>
          </DataContext.Provider>
        </DemoPaper>
      </Container>
    </div>
  );
}

export default App;
